import { useEffect, useState } from "react";

/** Keep the second click of a room double-click clear of newly mounted controls. */
export function useDelayedRoomControls(room: object | undefined): boolean {
  const [visibleRoom, setVisibleRoom] = useState<object>();

  useEffect(() => {
    setVisibleRoom(undefined);
    if (!room) return;
    const timer = window.setTimeout(() => setVisibleRoom(room), 300);
    return () => window.clearTimeout(timer);
  }, [room]);

  return room !== undefined && visibleRoom === room;
}
